// src/theme/cores.js

/**
 * Azul claro de destaque do layout do produto LEITE (item selecionado da barra lateral,
 * ação "Acompanhar", ícone e barra de progresso do ensaio em andamento). Mais claro que
 * o `primary` do tema, que segue sendo a cor das ações principais.
 */
export const AZUL_CLARO = '#2F80ED';
